namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailProgramovaInstance extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GProgramovaInstanceReadDto;
        private newRecord: boolean;
        private detailObj: DetailProgramovaInstanceObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailProgramovaInstanceObj());
            this.detailObj.createBase({
                contentName: "detailProgramovaInstance",
                contentCaption: "jres:29929931",  //RC 33000682 : URL webov� aplikace
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getParametryProInstanceTab());
                tabs.push(this.detailObj.getKonfiguracniSkupinyFunkcniMistaInstanceTab(false))
                tabs.push(this.detailObj.getKonfiguracniSkupinyFunkcniMistaInstanceTab(true))
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getParametryProInstanceGroup());
                groups.push(this.detailObj.getKonfiguracniSkupinyFunkcniMistaInstanceGroup(false));
                groups.push(this.detailObj.getKonfiguracniSkupinyFunkcniMistaInstanceGroup(true));
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailProgramovaInstance", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailProgramovaInstanceObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GProgramovaInstanceReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return "{0}".format((this.data.ixs_ins) ? this.data.ixs_ins.toString() : "");
        }

        saveData(data: any, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.ProgramovaInstance.upsert({ data: data }).get() as any).done((output) => {
                Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderGinsins");
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailProgramovaInstance", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.ProgramovaInstance.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${(this.data.nazev) ? this.data.nazev : ''}`;
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                {
                    favorite: true,
                    type: "static",
                    visible: this.options.newRecord == false,
                    caption: "jres:33000138",
                    icon: "fa-link",
                    children: [
                        { action: this.cnt.actions.actOpenSeznamKonfiguracniSkupina },
                        { action: this.cnt.actions.actOpenSeznamFunkcniMisto }
                    ]
                },
                "actDeleteEkoini*",
                "actDeleteAplSetting*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOpenSeznamKonfiguracniSkupina: {
                    caption: "jres:33000776",
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.actOpenSeznamKonfiguracniSkupina(false)
                    }
                },
                actOpenSeznamFunkcniMisto: {
                    caption: "jres:33000777",
                    icon: "fa-link",
                    run: (ev, ctx) => {
                        this.actOpenSeznamKonfiguracniSkupina(true)
                    }
                },
                actDeleteEkoini: {
                    caption: "jres:33000787", //RC 33000787 : Vymazat ekoinicializaci instance
                    icon: "gi-settings",
                    run: (ev, ctx) => {
                        this.cnt.actions.actDeleteEkoini?.setPending(this.deleteEkoinit())
                    }
                },
                actDeleteAplSetting: {
                    caption: "jres:33000788", //RC 33000788 : Vymazat u�ivatelsk� nastaven� instance
                    icon: "gi-settings",
                    run: (ev, ctx) => {
                        this.cnt.actions.actDeleteAplSetting?.setPending(this.deleteAplSetting())
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            if (this.options.newRecord == true) {
                if (this.data.faze)
                    this.cnt.findFields("faze").gfield("disable");
            }
            this.cnt.actions.actDeleteAplSetting?.update({ enabled: !editMode })
            this.cnt.actions.actDeleteEkoini?.update({ enabled: !editMode })
            this.cnt.actions.actOpenSeznamKonfiguracniSkupina?.update({ enabled: !editMode })
            this.cnt.actions.actOpenSeznamFunkcniMisto?.update({ enabled: !editMode })
        }

        createForm() {
            this.MakeField("ixs_ins");
            this.MakeSelectField("faze", Gordic.Prefabs.Select.gincfaz(), { model: "model.faze=value.faze", dropdown: false });
            this.MakeField("zkratka");
            this.MakeField("nazev");
            this.MakeField("poznamka");
            this.MakeField("dat_od");
            this.MakeField("dat_do", { validators: [ this.getValidatorDatOdDo() ] });
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita=value.aktivita" });
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        getParametryProInstanceTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-parametry-instance",
                    title: "jres:33000775", //RC 33000775 : Parametry instance
                    opened: true,
                    locked: true,
                    group: { id: "_tab-parametry-instance" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmParametrGlobal",
                    serverParams: {
                        ID: "SeznamAdmParametrGlobal",
                        ixs_ins: this.data.ixs_ins,
                        uroven_cfg: 40,
                        tabOpen: true
                    }
                }
            }
        }

        getKonfiguracniSkupinyFunkcniMistaInstanceTab(funkcniMisto: boolean): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: (funkcniMisto == true) ? "tab-funkcni-mista-instance" : "tab-konfiguracni-skupiny-instance",
                    title: (funkcniMisto == true) ? "jres:33000777" : "jres:33000776",
                    opened: true,
                    locked: true,
                    group: { id: (funkcniMisto == true) ? "_tab-funkcni-mista-instance" : "_tab-konfiguracni-skupiny-instance" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmKonfiguracniSkupinaProgramovaInstance",
                    serverParams: {
                        ID: "SeznamAdmKonfiguracniSkupinaProgramovaInstance",
                        ixs_ins: this.data.ixs_ins,
                        typ_usr: funkcniMisto == true ? 10 : 0,  // B�n� konfigura�n� skupina
                        tabOpen: true
                    }
                }
            }
        }

        getParametryProInstanceGroup(): IGTabGroupOptions {
            return { id: "_tab-parametry-instance", caption: "jres:33000775" }
        }

        getKonfiguracniSkupinyFunkcniMistaInstanceGroup(funkcniMisto: boolean): IGTabGroupOptions {
            return {
                id: (funkcniMisto == true) ? "_tab-funkcni-mista-instance" : "_tab-konfiguracni-skupiny-instance",
                caption: (funkcniMisto == true) ? "jres:33000777" : "jres:33000776"
            }
        }

        private actOpenSeznamKonfiguracniSkupina(funkcniMisto: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.SeznamAdmKonfiguracniSkupinaProgramovaInstance", {
                ixs_ins: this.data.ixs_ins,
                typ_usr: funkcniMisto == true ? 10 : 0  // B�n� konfigura�n� skupina
            }])
        }

        private deleteEkoinit(): JQueryPromise<undefined> {
            var _this = this;
            return $.Deferred(function () {
                var def = this;
                if (_this.data.ixs_ins) {
                    _this.cnt.isl.ProgramovaInstance.deleteEkoinit({ instance: [_this.data.ixs_ins] }).get().then((data) => {
                        if (data.length > 0)
                            return def.resolve().promise();
                        else
                            return def.reject().promise();
                    }).catch(() => {
                        return def.reject().promise();
                    });
                }
            })
        }

        private deleteAplSetting(): JQueryPromise<undefined> {
            var _this = this;
            return $.Deferred(function () {
                var def = this;
                if (_this.data.ixs_ins) {
                    _this.cnt.isl.ProgramovaInstance.deleteAplSettings({ instance: [_this.data.ixs_ins] }).get().then((data) => {
                        if (data.length > 0)
                            return def.resolve().promise();
                        else 
                            return def.reject().promise();
                    }).catch(() => {
                        return def.reject().promise();
                    })
                }
            })
        }
    }
}
